import { refreshNotaryEntitlementSession } from "@Front/Utils/refreshNotaryEntitlementSession";

type PermissionsRefreshFn = () => Promise<void>;

let registeredPermissionsRefresh: PermissionsRefreshFn | null = null;
let registeredUserUid: string | null = null;

export function registerNotaryPermissionsRefresh(refresh: PermissionsRefreshFn, userUid: string | null): void {
	registeredPermissionsRefresh = refresh;
	registeredUserUid = userUid;
}

export function unregisterNotaryPermissionsRefresh(): void {
	registeredPermissionsRefresh = null;
	registeredUserUid = null;
}

/**
 * Rafraîchit JWT + affiliations + matrice permissions (best-effort hors arbre React).
 */
export async function triggerNotaryEntitlementRefresh(
	logLabel: string,
	userUid?: string | null,
	options?: { skipJwtRefresh?: boolean },
): Promise<void> {
	const effectiveUserUid = userUid ?? registeredUserUid;
	await refreshNotaryEntitlementSession({
		userUid: effectiveUserUid,
		refreshPermissions: registeredPermissionsRefresh ?? (async (): Promise<void> => undefined),
		logLabel,
		skipJwtRefresh: options?.skipJwtRefresh,
	});
}
